/*
 * ÁNIMUS · Rutina en la ficha (Completa tu rutina, version A). 13-oct-2026.
 *
 * El bloque llega por /recommendations/products y se inserta con innerHTML,
 * asi que los scripts que trae no corren: este archivo se carga con la ficha
 * y arma cada bloque [data-an-ru] cuando aparece.
 *
 * - Suma lo marcado mas el producto de la ficha (la variante elegida en el
 *   formulario principal), salvo lo que ya esta en el carrito.
 * - El regalo de la semana (BOGOS, window.anOfertaViva) no se vende: se marca
 *   «Regalo» y no entra en la cuenta.
 * - Debajo del boton dice cuanto falta para el regalo o para el envio gratis,
 *   con el carrito real.
 */
(function () {
  'use strict';
  if (window.anRutinaFicha) { return; }
  window.anRutinaFicha = 1;

  var ENVIO_GRATIS = 19500000;
  var carrito = null;

  function pesos(c) {
    return '$' + Math.round(c / 100).toLocaleString('es-CO');
  }

  function leeCarrito() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; return c; })
      .catch(function () { return null; });
  }

  function enCarrito(id) {
    if (!carrito || !id) { return false; }
    return carrito.items.some(function (i) { return String(i.variant_id) === String(id); });
  }

  function precios(box) {
    try { return JSON.parse(box.querySelector('[data-an-ru-precios]').textContent); } catch (e) { return {}; }
  }

  function idActual(box) {
    var sec = box.closest('.shopify-section') || document;
    var f = sec.querySelector('form[action*="/cart/add"]:not([data-quickbuy-form]) [name="id"]');
    return f ? String(f.value) : '';
  }

  function pinta(box) {
    var oferta = window.anOfertaViva ? window.anOfertaViva() : null;
    var cuenta = 0;
    var total = 0;
    var quedan = 0;

    box.querySelectorAll('[data-an-ru-paso]').forEach(function (paso) {
      var h = paso.getAttribute('data-an-ru-handle');
      var esActual = paso.classList.contains('an-ru__paso--este');
      var chk = paso.querySelector('[data-an-ru-v]');

      if (esActual) {
        var id = idActual(box);
        var ya = enCarrito(id);
        var etq = paso.querySelector('[data-an-ru-este]');
        if (etq) { etq.textContent = ya ? 'En tu carrito' : 'Este'; }
        // 20-oct-2026: lo que ya esta en el carrito no se muestra
        paso.hidden = ya;
        if (!ya) { quedan += 1; }
        if (!ya && id) {
          var p = precios(box)[id];
          if (p) { cuenta += 1; total += p; }
        }
        return;
      }

      // regalo de la semana: no se vende, se marca
      var i = oferta && oferta.handles ? oferta.handles.indexOf(h) : -1;
      if (i > -1) {
        if (!paso.hasAttribute('data-an-ru-regalo')) {
          paso.setAttribute('data-an-ru-regalo', '');
          var r = (oferta.regalos || [])[i] || {};
          var lin = paso.querySelector('[data-an-ru-lin]');
          if (lin) {
            lin.textContent = (r.ml ? 'El de ' + r.ml : 'Este') + (oferta.min <= 100 ? ' va de regalo con cualquier compra.' : ' va de regalo desde ' + pesos(oferta.min) + '.');
          }
          ['[data-an-ru-sel]', '[data-an-ru-precio]'].forEach(function (s) {
            var e = paso.querySelector(s);
            if (e) { e.hidden = true; }
          });
          var lab = chk ? chk.closest('label') : null;
          if (lab) {
            var reg = document.createElement('span');
            reg.className = 'an-ru__reg';
            reg.textContent = 'Regalo';
            lab.replaceWith(reg);
          }
        }
        return;
      }

      if (paso.hasAttribute('data-an-ru-en')) { paso.hidden = true; return; }
      if (!chk) { return; }
      if (enCarrito(chk.getAttribute('data-an-ru-v'))) {
        paso.setAttribute('data-an-ru-en', '');
        paso.hidden = true;
        var lab2 = chk.closest('label');
        if (lab2) {
          var est = document.createElement('span');
          est.className = 'an-ru__este';
          est.textContent = 'En tu carrito';
          lab2.replaceWith(est);
        }
        return;
      }
      quedan += 1;
      if (chk.checked) {
        cuenta += 1;
        total += Number(chk.getAttribute('data-an-ru-p') || 0);
      }
    });

    // los numeros de paso se cuentan solo entre los que se ven
    var nn = 0;
    box.querySelectorAll('[data-an-ru-paso]').forEach(function (p) {
      var s = p.querySelector('.an-ru__n');
      if (s && !p.hidden) { nn += 1; s.textContent = nn; }
    });
    // si ya no queda nada por agregar, el bloque y su titulo se ocultan
    var cont = box.closest('complementary-products') || box;
    cont.style.display = carrito && quedan === 0 ? 'none' : '';
    var c = box.querySelector('[data-an-ru-cuantos]');
    var t = box.querySelector('[data-an-ru-total]');
    var b = box.querySelector('[data-an-ru-add]');
    var n = box.querySelector('[data-an-ru-nota]');
    if (c) { c.textContent = cuenta === 0 ? '' : (cuenta === 1 ? '1 producto' : cuenta + ' productos'); }
    if (t) { t.textContent = cuenta ? pesos(total) : ''; }
    if (b && !b.hasAttribute('data-hecho')) {
      b.disabled = cuenta === 0;
      b.textContent = cuenta === 0 ? 'Tu rutina ya está en el carrito' : 'Agregar la rutina';
    }

    meta(box, base(), total, oferta, cuenta);
    if (n && !n.hasAttribute('data-error')) { n.hidden = true; }
  }

  function base() {
    return carrito ? carrito.total_price : 0;
  }

  // Barra de metas: en negro lo que ya esta en el carrito, en gris lo que
  // suma la rutina marcada. Hitos: el regalo de la semana (si hay) y el
  // envio gratis. Se mueve cada vez que la clienta marca o desmarca.
  function meta(box, ya, suma, oferta, cuenta) {
    var m = box.querySelector('[data-an-ru-meta]');
    if (!m) {
      m = document.createElement('div');
      m.className = 'an-ru__meta';
      m.setAttribute('data-an-ru-meta', '');
      m.innerHTML = '<p class="an-ru__meta-txt" aria-live="polite"></p>' +
        '<div class="an-ru__barra" aria-hidden="true"><span class="an-ru__suma"></span><span class="an-ru__ya"></span></div>' +
        '<div class="an-ru__hitos" aria-hidden="true"></div>';
      var tot = box.querySelector('.an-ru__tot');
      box.insertBefore(m, tot);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { m.classList.add('an-ru__meta--ve'); io.disconnect(); }
        }, { threshold: 0.25 });
        io.observe(m);
      } else {
        m.classList.add('an-ru__meta--ve');
      }
      // respaldo: si el observador no avisa, la barra se llena igual
      setTimeout(function () { m.classList.add('an-ru__meta--ve'); }, 4000);
    }
    var tope = ENVIO_GRATIS;
    var despues = ya + suma;
    var regalo = oferta && oferta.min < tope ? oferta.min : 0;
    if (ya >= tope) { m.hidden = true; return; }
    m.hidden = false;

    var txt;
    var falta = function (x) { return '<b>' + pesos(x) + '</b>'; };
    var pal = oferta ? oferta.palabra : 'regalo';
    var con = cuenta ? 'Con la rutina ' : '';
    if (regalo && ya < regalo) {
      if (despues >= tope) {
        txt = con + 'te llevas tu <b>' + pal + ' de regalo</b> y el <b>envío gratis</b>.';
      } else if (despues >= regalo) {
        txt = con + 'te llevas tu <b>' + pal + ' de regalo</b>. Te faltan ' + falta(tope - despues) + ' para el envío gratis.';
      } else {
        txt = con + 'te faltan ' + falta(regalo - despues) + ' para tu ' + pal + ' de regalo.';
      }
    } else if (despues >= tope) {
      txt = con + 'tu <b>envío es gratis</b>.';
    } else {
      txt = con + 'te faltan ' + falta(tope - despues) + ' para el envío gratis.';
    }
    txt = txt.charAt(0).toUpperCase() + txt.slice(1);
    m.querySelector('.an-ru__meta-txt').innerHTML = txt;

    var f = function (x) { return Math.max(0, Math.min(1, x / tope)); };
    m.style.setProperty('--an-ru-ya', f(ya));
    m.style.setProperty('--an-ru-suma', f(despues));

    var hitos = '';
    if (regalo) {
      hitos += '<span class="an-ru__hito' + (despues >= regalo ? ' an-ru__hito--listo' : '') +
        '" style="left:' + (f(regalo) * 100).toFixed(1) + '%">Regalo</span>';
    }
    hitos += '<span class="an-ru__hito an-ru__hito--fin' + (despues >= tope ? ' an-ru__hito--listo' : '') +
      '">Envío<span class="an-ru__hito-mas"> gratis</span></span>';
    m.querySelector('.an-ru__hitos').innerHTML = hitos;
    var marcas = m.querySelector('.an-ru__barra');
    marcas.setAttribute('data-regalo', regalo ? (f(regalo) * 100).toFixed(1) : '');
    marcas.style.setProperty('--an-ru-hito', regalo ? f(regalo) * 100 + '%' : '-10px');
  }

  function arma(box) {
    if (box.hasAttribute('data-an-ru-listo')) { return; }
    box.setAttribute('data-an-ru-listo', '');
    pinta(box);
    leeCarrito().then(function () { pinta(box); });
  }

  function todos() {
    document.querySelectorAll('[data-an-ru]').forEach(arma);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var box = t.closest('[data-an-ru]');
    if (box && t.matches('[data-an-ru-sel]')) {
      var o = t.options[t.selectedIndex];
      var paso = t.closest('[data-an-ru-paso]');
      var chk = paso.querySelector('[data-an-ru-v]');
      if (chk) {
        chk.setAttribute('data-an-ru-v', o.value);
        chk.setAttribute('data-an-ru-p', o.getAttribute('data-precio'));
      }
      var pr = paso.querySelector('[data-an-ru-precio]');
      var antes = Number(o.getAttribute('data-antes') || 0);
      var ahora = Number(o.getAttribute('data-precio') || 0);
      if (pr) { pr.innerHTML = pesos(ahora) + (antes > ahora ? ' <s>' + pesos(antes) + '</s>' : ''); }
    }
    // tambien cambia si la clienta escoge otro tamano en la ficha
    document.querySelectorAll('[data-an-ru-listo]').forEach(pinta);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-an-ru-add]');
    if (!b || b.disabled || b.hasAttribute('data-enviando')) { return; }
    e.preventDefault();
    var box = b.closest('[data-an-ru]');
    b.setAttribute('data-enviando', '');
    b.textContent = 'Agregando';
    leeCarrito().then(function () {
      var items = [];
      var id = idActual(box);
      if (id && !enCarrito(id)) { items.push({ id: Number(id), quantity: 1 }); }
      box.querySelectorAll('[data-an-ru-paso]:not([data-an-ru-regalo]) [data-an-ru-v]').forEach(function (chk) {
        var v = chk.getAttribute('data-an-ru-v');
        if (chk.checked && !enCarrito(v)) { items.push({ id: Number(v), quantity: 1 }); }
      });
      if (!items.length) { throw new Error('nada'); }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) {
      if (!r.ok) { throw new Error('no'); }
      b.removeAttribute('data-enviando');
      b.setAttribute('data-hecho', '');
      b.disabled = true;
      b.textContent = 'Tu rutina está en el carrito';
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return leeCarrito();
    }).then(function () { pinta(box); })
      .catch(function () {
        b.removeAttribute('data-enviando');
        b.textContent = 'Agregar la rutina';
        var n = box.querySelector('[data-an-ru-nota]');
        if (n) { n.textContent = 'No se pudo agregar. Intenta de nuevo.'; n.setAttribute('data-error', ''); n.hidden = false; }
      });
  });

  new MutationObserver(todos).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todos);
  } else {
    todos();
  }
})();
